import script from "./bonusomat-onboarding-carousel.vue?vue&type=script&lang=ts&setup=true"
export * from "./bonusomat-onboarding-carousel.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__